import { ProductMaterialDto } from "src/dtos/productMaterial/ProductMaterialDto";
import { formatDate } from "src/utils/string/stringUtil";

// KSK2101_R01 전용 DTO (백엔드 KSK2101_R01RowDto 매핑)
export interface KSK2120_R01Dto extends ProductMaterialDto {

	pastWorkNo: string;			// 과거 작업지시번호
	nowWorkNo: string;			// 현재 작업지시번호

	prntItemcd: string;          // 상위품목코드
	childItemcd: string;         // 하위품목코드
	itemNm: string;              // 품목명
	coordinateUsage: number;  // 좌표사용량 합계
	materialIntype: string;      // 공급구분 (BOM / PURCHASE 등)

	processType: string;        // PAST / NOW
	// remark: string;             // 회수필요 / 장착필요 / 공백

}

export const defaultKSK2120_R01Dto: KSK2120_R01Dto = {
    valueIndex: 0,
    orderIndex: 0,
    orderIndexSeq: 0,

	productWorkNo: '',
	orderDt: formatDate(new Date()),
	workplaceCd: '',
	feederNo: '',
	lotNo: '',
	itemCd: '',
	lotQty: 0,
	remark: '',

	pastWorkNo: '',
	nowWorkNo: '',

	prntItemcd: '',
	childItemcd: '',
	itemNm: '',
	coordinateUsage: 0,
	materialIntype: '',

	processType: '',

    inserted: false,
    isModified: false,
};

